/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbContactSummary } from './HchbContactSummary';
import {
    HchbContactSummaryFromJSON,
    HchbContactSummaryFromJSONTyped,
    HchbContactSummaryToJSON,
    HchbContactSummaryToJSONTyped,
} from './HchbContactSummary';

/**
 * 
 * @export
 * @interface HchbFacilitySummary
 */
export interface HchbFacilitySummary {
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    telephone?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    facility_type?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    county?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbFacilitySummary
     */
    npi?: string;
    /**
     * 
     * @type {Array<HchbContactSummary>}
     * @memberof HchbFacilitySummary
     */
    contacts?: Array<HchbContactSummary>;
}

/**
 * Check if a given object implements the HchbFacilitySummary interface.
 */
export function instanceOfHchbFacilitySummary(value: object): value is HchbFacilitySummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function HchbFacilitySummaryFromJSON(json: any): HchbFacilitySummary {
    return HchbFacilitySummaryFromJSONTyped(json, false);
}

export function HchbFacilitySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbFacilitySummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'telephone': json['telephone'] == null ? undefined : json['telephone'],
        'facility_type': json['facility_type'] == null ? undefined : json['facility_type'],
        'street': json['street'] == null ? undefined : json['street'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'county': json['county'] == null ? undefined : json['county'],
        'npi': json['npi'] == null ? undefined : json['npi'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(HchbContactSummaryFromJSON)),
    };
}

export function HchbFacilitySummaryToJSON(json: any): HchbFacilitySummary {
    return HchbFacilitySummaryToJSONTyped(json, false);
}

export function HchbFacilitySummaryToJSONTyped(value?: HchbFacilitySummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'city': value['city'],
        'state': value['state'],
        'telephone': value['telephone'],
        'facility_type': value['facility_type'],
        'street': value['street'],
        'zip': value['zip'],
        'county': value['county'],
        'npi': value['npi'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(HchbContactSummaryToJSON)),
    };
}

